
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

// Images
const interiorImage = "/lovable-uploads/f62966e4-bcd4-4bf5-8dc2-f7ef233197ad.png";

const IntroductionSection = () => {
  return (
    <section className="pt-6 pb-16 md:pt-8 md:pb-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            className="space-y-6" 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block text-cottage-600 font-medium text-4xl px-3 py-1 bg-cottage-50 rounded-full italic" style={{ fontFamily: "'Brush Script MT', 'Segoe Script', cursive" }}>See you at The Cottage</span>
            <h2 className="text-3xl md:text-4xl font-bold text-cottage-800">
              A Peaceful 4 Bedroom Retreat in Rural Tasmania
            </h2>
            <p className="text-cottage-600 leading-relaxed">Built in 1880 and fully renovated in 2023, The Cottage at Flowerpot is a peaceful retreat in Tasmania on a working farm in Southern Tasmania. This 4 bedroom accommodation sleeps up to 8 guests in four queen bed bedrooms — ideal Tasmania accommodation for families and multi-generational holidays. Features include two living areas, central heating, a full kitchen, a ten person dining room, and a sensational bathroom. Outdoors, enjoy the lavender gardens, clawfoot bath, infrared sauna, and a huge deck with uninterrupted views to Bruny Island.</p>
            <p className="text-cottage-600 leading-relaxed">Whether you're travelling from mainland Australia to Tasmania for a family vacation, an artist retreat, a writer's retreat, or an executive getaway, this Flowerpot family holiday house provides the ideal setting for creating lasting memories.</p>
            <div>
              <Link to="/details">
                <Button variant="outline" className="border-cottage-200 text-cottage-700 hover:text-cottage-800 hover:border-cottage-300">
                  Learn More <ChevronRight size={16} className="ml-2" />
                </Button>
              </Link>
            </div>
          </motion.div>

          <motion.div 
            className="relative rounded-lg overflow-hidden shadow-xl" 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img src={interiorImage} alt="Peaceful retreat in Tasmania - cozy interior of 4 bedroom accommodation at Flowerpot" className="w-full h-[400px] md:h-[500px] object-cover" />
            <div className="absolute bottom-4 left-4 right-4">
              <div>
                <h3 className="text-sm sm:text-base text-white shadow-[0_0_3px_rgba(0,0,0,0.8)] bg-black/20 backdrop-blur-sm py-1 px-3 rounded-md inline-block mb-2">Experience Comfort</h3>
                <p className="text-sm sm:text-base text-white shadow-[0_0_3px_rgba(0,0,0,0.8)] bg-black/20 backdrop-blur-sm py-1 px-3 rounded-md inline-block">
                  Modern amenities with rustic charm
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default IntroductionSection;
